// extracted by mini-css-extract-plugin
export default {"status":"ChangeOrderStatus_status__QlVSP","card":"ChangeOrderStatus_card__Y0pCj"};